import React from 'react';
import { InfoOutlined } from '@material-ui/icons';
import {
  PrinterStationConfigStatus,
  PrinterStationConfigStatusLabel,
  PrinterStationConfigStatusValue,
  PrinterStationConfigStatusIcon,
} from './styles';

interface PrinterStatusValueProps {
  available: boolean;
}

const PrinterStatusValue: React.FC<PrinterStatusValueProps> = ({ available }) => (
  <PrinterStationConfigStatusValue available={available}>
    {available ? 'Disponível' : 'Indisponível'}
  </PrinterStationConfigStatusValue>
);

interface PrinterStationStatusProps {
  available: boolean;
}

const PrinterStationStatus: React.FC<PrinterStationStatusProps> = ({ available }) => (
  <PrinterStationConfigStatus>
    <PrinterStationConfigStatusIcon>
      <InfoOutlined fontSize="small" />
    </PrinterStationConfigStatusIcon>
    <PrinterStationConfigStatusLabel>Status da impressora local:</PrinterStationConfigStatusLabel>
    <PrinterStatusValue available={available} />
  </PrinterStationConfigStatus>
);

export default PrinterStationStatus;
